import { getLanguages } from 'utils/languages'

export const mapInternalStateToPayload = state => {
  const { email, language, name, phone } = state ?? {}

  return {
    language: language?.value,
    email,
    name,
    phone,
  }
}

export const mapCandidateToInternalState = state => {
  const { email, language, name, phone } = state ?? {}

  return {
    language: getLanguages().find(option => option.value === language),
    email,
    name,
    phone,
  }
}
